module.exports = __webpack_public_path__ + "static/media/a1.f2253bd0.jpg";